import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { painPoints } from '@/mocks/smart-farm';

export default function PainPoints() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="行业痛点"
          title="农业经营，不应只靠经验与信息差"
          subtitle="农业经营链路长、参与主体多。生产端缺少实时数据，品质端缺少可信记录，销售端缺少稳定连接，最终影响农产品价值释放。"
        />
        <Reveal className="mt-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {painPoints.map((point) => (
              <div
                key={point.id}
                className="p-6 rounded-lg bg-background-100 border border-background-200 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(0,0,0,0.08)]"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${point.icon} text-2xl`}></i>
                </div>
                <h3 className="mt-5 font-heading font-bold text-foreground-950 text-lg leading-snug">
                  {point.title}
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{point.desc}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}